



import MainBanner from '../sections/banner/template_01';







import SpeakerAnnouncement from '../sections/speaker_announcement/template_01';







// import Games from '../sections/games/template_01';






import SECTION_SECTION_DISCOVER_GAMES from
'../dynamic_section/dynamic_1/template_02';





import SECTION_SECTION_SLOT_GAMES from
'../dynamic_section/dynamic_1/template_02';





import SECTION_SECTION_LIVE_CASINO from
'../dynamic_section/dynamic_1/template_01';





import SECTION_1675926682244 from
'../dynamic_section/dynamic_1/template_02';






import RankingList from '../sections/ranking/template_02';



import SECTION_SECTION_MAINPAGE_PROMOTION from
'../dynamic_section/dynamic_1/template_02';


import SECTION_SHOPCONTAINER_1 from
'../dynamic_section/dynamic_1/template_01';





import SECTION_SECTION_HOW_TO_REGISTER_D from
'../dynamic_section/dynamic_2/template_01';


import SECTION_SECTION_HOWTOREGISTER_M from
'../dynamic_section/dynamic_2/template_01';


import "./style.css";
import FloatingIcon from '../components/FloatingIcon';
import { useEffect, useState } from "react";
import { useMiddletier } from "../common/middletier";
import { useTranslation } from 'react-i18next';


const Main = ()=>{
  const [floatingIcon, setFloatingIcon] = useState([])
  const { queries, mutation } = useMiddletier()
  const { t, i18n } = useTranslation();
  useEffect(() => {
    queries([
      {
        index: 'getFloatingIcons',
        method: 'getFloatingIcons',
        params: [
          { code: 'language', graphqlType: 'String', required: true, value: i18n.resolvedLanguage },
          { code: 'website', graphqlType: 'String', required: false, value: 'MALL' },
        ],
        attributes: []
      }
    ])
      .then(({ data }) => {
        setFloatingIcon(data['getFloatingIcons'])
      })
      .catch((error) => {
        console.error(error)
      })
  }, [queries, i18n.resolvedLanguage])
return (
  <div id="main" class="page ">
  
  

  
  <MainBanner navigation={ false } speed={
    2.5 } pagination={ true } />
  
  
  
  

  
  
  <SpeakerAnnouncement desktopToggle={ true } mobileToggle={
    true } iconToggle={ true } titleToggle={
    false } />
  
  
  
  < SECTION_SECTION_HOW_TO_REGISTER_D desktopToggle={ true }
    mobileToggle={ false } label={ `Section_howtoregister_d` } id={ `Section_howtoregister_mall` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ true } />
  
  
  
  

  
  < SECTION_SECTION_HOWTOREGISTER_M desktopToggle={ false }
    mobileToggle={ true } label={ `Section_howtoregister` } id={ `Section_howtoregister_mall_m` } supportLanguage={
      true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ true } />
  
  < SECTION_SHOPCONTAINER_1 desktopToggle={ true }
    mobileToggle={ true } label={ `Hot Product` } id={ `Section_shop` }
    imageSize={`1x1`} contentPosition={`bottom`}
    actionPosition={`bottom`} rowDesktop={ 5 }
    rowMobile={ 2 } numberOfRow={ 2 }
    dataType={`product`} noPadding={ false } filter={`hot`}
    titleToggle={ true } titleIconToggle={ false }
    cardPosition={``} pagination={ true }
    autoplay={ true } navigation={ true }
    dynamicQuery={`` } filterTabToggle={ false }
    folderImage={``} noLink={ false }/>

  
  < SECTION_SHOPCONTAINER_1 desktopToggle={ true }
    mobileToggle={ true } label={ `Product` } id={ `Section_shop` }
    imageSize={`1x1`} contentPosition={`bottom`}
    actionPosition={`bottom`} rowDesktop={ 5 }
    rowMobile={ 2 } numberOfRow={ 2 }
    dataType={`product`} noPadding={ false } filter={``}
    titleToggle={ true } titleIconToggle={ false }
    cardPosition={``} pagination={ true }
    autoplay={ true } navigation={ true }
    dynamicQuery={`` } filterTabToggle={ false }
    folderImage={``} noLink={ false }/>


< SECTION_SECTION_MAINPAGE_PROMOTION desktopToggle={ true }
    mobileToggle={ true } label={ `Section_mainPage_promotion` } id={ `Section_mainPage_promotion` }
    imageSize={`1x3`} contentPosition={`none`}
    actionPosition={`none`} rowDesktop={ 1 }
    rowMobile={ 1 } numberOfRow={ 1 }
    dataType={`promotion`} noPadding={ false } filter={``}
    titleToggle={ true } titleIconToggle={ false }
    cardPosition={``} pagination={ false }
    autoplay={ true } navigation={ false }
    dynamicQuery={`` } filterTabToggle={ false }
    folderImage={``} noLink={ false }/>
  

{floatingIcon.length > 0 && (floatingIcon?.map(function (item, index) {
        return (
          <FloatingIcon position={item?._floating_icon?.position} enableClose={item?._floating_icon?.enable_close} enableMove={item?._floating_icon?.enable_move} desktopImageUrl={item?.desktop_image_url} mobileImageUrl={item?.mobile_image_url} url={item?._floating_icon?.url} />)
      }))}
  
</div>
)
}

export default Main;